import { render, staticRenderFns } from "./ClientsGridContentEdit.vue?vue&type=template&id=31680e16"
import script from "./ClientsGridContentEdit.vue?vue&type=script&lang=ts"
export * from "./ClientsGridContentEdit.vue?vue&type=script&lang=ts"
import style0 from "./ClientsGridContentEdit.vue?vue&type=style&index=0&id=31680e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports